// extracted by mini-css-extract-plugin
module.exports = {"SrFlexRow":"SrFlexRow--SrFlexRow--3vxWV","highlightYellowFadeIn":"SrFlexRow--highlightYellowFadeIn--1bjy3"};